import { Modal } from 'react-bootstrap';
import CoinSelectDropdown from "../../components/CoinSelectDropdown";
import walletIcon from '../../assets/images/icons/wallet-gray-icon.svg';
import { useState, memo } from 'react';
import { config } from '../../config.js';
import crossIcon from '../../assets/images/icons/cross-gray-icon.svg';

function Addwallet(props) {
    const [AddwalletCoinSelect, setAddwalletCoinSelect] = useState('crypto');
    const [walletName, setWalletName] = useState('');
    const [walletAddress, setWalletAddress] = useState('');
    const [whiltListError, setWhiltListError] = useState(false);
    const [bankName, setBankName] = useState('');
    const [IFSCcode, setIFSCCode] = useState('');
    const [bankAccount, setBankAccount] = useState('');
    const [selectCurrencyData, setSelectCurrencyData] = useState(null);

    const onSelectAddAddwalletWallet = (value) => {
        if (value.type === 'C') {
            setAddwalletCoinSelect('crypto');
        } else {
            setAddwalletCoinSelect('fiat');
        }
        setSelectCurrencyData(value);
    };

    const confirmButtonHandel = async () => {
        if (AddwalletCoinSelect === 'crypto') {
            if (!walletAddress || !walletName) {
                setWhiltListError('Please enter both Wallet Address and Wallet Name');
                return;
            }
        } else {
            if (!bankName || !IFSCcode || !bankAccount) {
                setWhiltListError('Please enter Bank Name, IFSC Code and Bank Account');
                return;
            }
        }

        const body = AddwalletCoinSelect === 'crypto'
            ? {
                email: props.email,
                currencycode: selectCurrencyData.shortName,
                currencyname: selectCurrencyData.label || '',
                type: selectCurrencyData.type || '',
                walletname: walletName,
                walletaddress: walletAddress,
                status: "Active"
            }
            : {
                email: props.email,
                currencycode: selectCurrencyData.shortName,
                currencyname: selectCurrencyData.label || '',
                type: selectCurrencyData.type || '',
                bankname: bankName,
                ifsccode: IFSCcode,
                bankaccountnumber: bankAccount,
                status: "Active"
            };

        try {
            const response = await fetch(config.API_BASE_URL + '/updateInsertAddWallet', {
                method: "POST",
                headers: {
                    'Content-Type': 'text/plain',
                },
                body: JSON.stringify(body)
            });
            const result = await response.json();
            // console.log(result);
            handleClose();
            window.location.href = '/add-wallet';
        } catch (error) {
            console.error('Error:', error);
            setWhiltListError('Failed to submit. Please try again.');
        }
    };

    const handleClose = () => {
        // Reset form state
        setWalletName('');
        setWalletAddress('');
        setBankName('');
        setIFSCCode('');
        setBankAccount('');
        setWhiltListError(false);
        setSelectCurrencyData(null);

        // Call parent close handlers
        props.onAddAddwalletWalletClose?.();
        props.onWithdrawClose?.();
    };

    return (
        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal deposit-select-wallet-modal assets-withdraw-modal"
            show={props.addAddwalletWalletShow}
            onHide={handleClose}
        >
            <Modal.Body>
                <div className="deposit-wallet-wrapper">
                    <div className="wallet-header">
                        <div className="row">
                            <div className="col-6 align-self-center">
                                <h3 className="h3">Add wallet</h3>
                            </div>
                            <div className="col-6 align-self-center">
                                <div className="reset-wrapper">
                                    <button
                                        className="close-button"
                                        onClick={handleClose}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            padding: 0,
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <img src={crossIcon} alt="Close" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wallet-body">
                        <div className="deposit-wrapper">
                            <div className="deposit-item">
                                {whiltListError && <span className='text-danger'>{whiltListError}</span>}
                                <h3>Asset</h3>
                                <CoinSelectDropdown
                                    options={props.UserCurrencyResponse}
                                    onSelect={(e) => {
                                        setWhiltListError(false);
                                        onSelectAddAddwalletWallet(e);
                                    }}
                                    placeholderIcon={walletIcon}
                                    className="coin-dropdown"
                                />
                            </div>

                            {AddwalletCoinSelect === 'crypto' && (
                                <div>
                                    <div className="deposit-item">
                                        <h3>Enter Wallet Name</h3>
                                        <div className="form">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    value={walletName}
                                                    onChange={(e) => {
                                                        setWhiltListError(false);
                                                        setWalletName(e.target.value);
                                                    }}
                                                    className="form-control"
                                                    placeholder="Enter wallet name here"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="deposit-item">
                                        <h3>Enter Address</h3>
                                        <div className="form">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    value={walletAddress}
                                                    onChange={(e) => {
                                                        setWhiltListError(false);
                                                        setWalletAddress(e.target.value);
                                                    }}
                                                    className="form-control"
                                                    placeholder="Enter address here"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {AddwalletCoinSelect === 'fiat' && (
                                <div>
                                    <div className="deposit-item">
                                        <h3>Enter Bank Name</h3>
                                        <div className="form">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    value={bankName}
                                                    onChange={(e) => {
                                                        setWhiltListError(false);
                                                        setBankName(e.target.value);
                                                    }}
                                                    className="form-control"
                                                    placeholder="Enter Bank Name here"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="deposit-item">
                                        <h3>IFSC</h3>
                                        <div className="form">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    value={IFSCcode}
                                                    onChange={(e) => {
                                                        setWhiltListError(false);
                                                        setIFSCCode(e.target.value);
                                                    }}
                                                    className="form-control"
                                                    placeholder="Enter IFSC here"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="deposit-item">
                                        <h3>Enter Account Number</h3>
                                        <div className="form">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    value={bankAccount}
                                                    onChange={(e) => {
                                                        setWhiltListError(false);
                                                        setBankAccount(e.target.value);
                                                    }}
                                                    className="form-control"
                                                    placeholder="Enter account number here"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="wallet-footer">
                        <ul className="btn-list">
                            <li>
                                <button
                                    className="btn-style"
                                    onClick={confirmButtonHandel}
                                    disabled={!selectCurrencyData}
                                >
                                    Confirm
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default memo(Addwallet);